import { Checkbox, FormControlLabel, FormGroup } from '@mui/material';
import { StyledSubOptionsContainer } from '../PdfExportConfigDialog.styles';
import { COMPANY_OPTION_CONFIGS, CompanyPdfOptions } from '../PdfExportConfigDialog.types';
import { CompanySubOptionsProps } from './SubOptions.types';

export const CompanySubOptions = ({ options, onOptionsChange, showCondition }: CompanySubOptionsProps) => {
  if (!showCondition) {
    return null;
  }

  const handleOptionChange = (optionKey: keyof CompanyPdfOptions) => {
    onOptionsChange({
      ...options,
      [optionKey]: !options[optionKey],
    });
  };

  return (
    <StyledSubOptionsContainer>
      <FormGroup>
        {COMPANY_OPTION_CONFIGS.map(({ key, label }) => (
          <FormControlLabel
            key={key}
            control={
              <Checkbox
                checked={options[key]}
                onChange={() => handleOptionChange(key)}
              />
            }
            label={label}
          />
        ))}
      </FormGroup>
    </StyledSubOptionsContainer>
  );
};
